import { render } from "./LayoutHome.vue?vue&type=template&id=ffe16064&scoped=true"
import script from "./LayoutHome.vue?vue&type=script&lang=js"
export * from "./LayoutHome.vue?vue&type=script&lang=js"

import "./LayoutHome.vue?vue&type=style&index=0&id=ffe16064&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe16064"]])

export default __exports__